import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content bg_gray d-flex flex-column transition overflow-hidden" }

import { onMounted } from "vue";

import BreadcrumbMenu from "../../components/Common/BreadcrumbMenu.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";
import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import CreateBrandModal from "../../components/Settings/Brand/CreateBrandModal.vue";
import BrandList from "../../components/Settings/Brand/BrandList.vue";
import { useBrand } from "../../composables/useBrand";


export default /*@__PURE__*/_defineComponent({
  __name: 'BrandListPage',
  setup(__props) {

const {
  searchQuery,
  filteredBrands,
  showModal,
  selectedBrand,
  form,
  errors,
  loading,
  previewUrl,
  paginationConfig,
  fetchBrands,
  openCreateModal,
  openEditModal,
  closeModal,
  updateField,
  handleFileUpload,
  removeImage,
  generateBrandCode,
  saveBrand,
  deleteBrand,
} = useBrand();

onMounted(fetchBrands);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(MainHeader),
    _createVNode(MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(BreadcrumbMenu, { pageTitle: "brand_page.list_title" }),
      _createVNode(BrandList, {
        brands: _unref(filteredBrands),
        "search-query": _unref(searchQuery),
        "pagination-config": _unref(paginationConfig),
        "onUpdate:searchQuery": _cache[0] || (_cache[0] = ($event: any) => (searchQuery.value = $event)),
        onCreate: _unref(openCreateModal),
        onEdit: _unref(openEditModal),
        onDelete: _unref(deleteBrand)
      }, null, 8, ["brands", "search-query", "pagination-config", "onCreate", "onEdit", "onDelete"]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      _createVNode(MainFooter),
      _createVNode(CreateBrandModal, {
        open: _unref(showModal),
        "is-edit": !!_unref(selectedBrand),
        form: _unref(form),
        errors: _unref(errors),
        loading: _unref(loading),
        "preview-url": _unref(previewUrl),
        onClose: _unref(closeModal),
        onSave: _unref(saveBrand),
        onGenerateCode: _unref(generateBrandCode),
        onUpdateField: _unref(updateField),
        onFileChange: _unref(handleFileUpload),
        onRemoveImage: _unref(removeImage)
      }, null, 8, ["open", "is-edit", "form", "errors", "loading", "preview-url", "onClose", "onSave", "onGenerateCode", "onUpdateField", "onFileChange", "onRemoveImage"])
    ])
  ], 64))
}
}

})